import React, { useState } from 'react';

// Components
import Asteric from './Asteric';

import visibilityOff from '../assets/images/auth-visibility-off.svg'
import visibilityOn from '../assets/images/auth-visibility-on.svg'

// Prime-react Components
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';

const CustomPassword = (props) => {
  const { htmlFor, text, ismandatory, isbold } = props;
  const [onFocus, setOnFocus] = useState(false);
  const [onBlur, setOnBlur] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleOnFocus = () => {
    setOnFocus(true);
    setOnBlur(false);
  };

  const handleOnBlur = () => {
    setOnFocus(false);
    setOnBlur(true);
  };

  return (
    <>
      {
        <>
          <label htmlFor={htmlFor} className={!isbold ? 'text-gray font-bold' : ''}>
            <span
              className={classNames({
                'input-focus': onFocus,
                'text-gray': onBlur
              })}>
              {text}
            </span>
          </label>
          {ismandatory && <Asteric />}
        </>
      }
      <span className="p-input-icon-right">
        {/* <i
          className={`pi ${showPassword ? 'pi-eye' : 'pi-eye-slash'}`}
          onClick={() => setShowPassword(!showPassword)}
        /> */}
        <em onClick={() => setShowPassword(!showPassword)}>
          <img src= { ` ${showPassword ? visibilityOn : visibilityOff}` } />
        </em>
        <InputText
          type={showPassword ? 'text' : 'password'}
          onFocus={handleOnFocus}
          onBlur={handleOnBlur}
          {...props}
        />
      </span>
    </>
  );
};

export default CustomPassword;
